import React, { useState } from 'react';
import './css/index.css';
import './css/login.css';
import { useNavigate } from 'react-router-dom';
import { FaMoon } from 'react-icons/fa';
import { FaSun } from 'react-icons/fa';

async function loginUser(info) {
  return fetch('/api/login', {
    method: 'POST',
    body: JSON.stringify(info),
    headers: { 'Content-Type': 'application/json' }
  }).then(res => res.json());
}

const Login = () => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [darkMode, setDarkMode] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const user_info = await loginUser({ username, password });
      if (user_info.error) throw new Error(user_info.error);
      localStorage.setItem('walmates-token', user_info.token);
      localStorage.setItem('walmates-user_id', user_info.id);
      localStorage.setItem('walmates-login_id', user_info.login_id);
      navigate('/music', { replace: true });
    } catch (err) {
      setError(String(err));
    }
  };

  return (
    <div className={`login-wrapper responsive ${darkMode ? 'dark' : ''}`}>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-title logo-header">
          <img src="/favicon.png" alt="logo" className="logo-icon" />
          <span className="brand-name">walmates</span>
        </div>

        <p className="login-subtitle">Please sign in to continue</p>

        <input
          type="text"
          className="login-input"
          placeholder="Email address"
          value={username}
          onChange={e => setUserName(e.target.value)}
          required
        />

        <input
          type="password"
          className="login-input"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />

        {error && <div className="login-error">{error}</div>}

        <button type="submit" className="login-button">Sign In</button>
      </form>
     <button className="dark-mode-fab" onClick={() => setDarkMode(!darkMode)}>
       {darkMode ? <FaSun size={16} /> : <FaMoon size={16} />}
     </button>
    </div>
  );
};

export default Login;

